<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->
      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">

        <el-form-item
          v-if="$store.state.roleId == '1070960390067716097'"
          label="代理"
        >
          <el-select 
            v-model="form.agentId" 
            placeholder="请选择代理"
            :popper-append-to-body="false"
            popper-class="eloption"
          >
            <el-option
              v-for="item in agentList"
              :key="item.agentId"
              :label="item.agentId + '-' + item.agentName"
              :value="item.agentId"
            ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            v-if="$store.state.roleId == '1070960390067716097' || $store.state.roleId == '2125410685723869666'"
            label="商户名称">
            <el-select v-model="form.appId" filterable placeholder="--请选择--"
              :popper-append-to-body="false"
              popper-class="eloption"
              >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="merchant in merchantList"
                :label="merchant.value + '-' + merchant.name"
                :key="merchant.value"
                :value="merchant.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="日期">
            <el-date-picker
              v-model="timeDate"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </template>


        <template slot="buttonArea">
          <el-button :loading="loading" type="primary" @click="exportDetail" size="small">
            导出报表</el-button>
        </template>


        <template slot="tableColumn">
          <!-- <el-table-column
            width="50"
            prop="id"
            label="id"
            align="center"
          ></el-table-column> -->

          <el-table-column
            width="120"
            prop="statisticsDate"
            label="日期"
            :formatter="$formatter.formatDate"
            align="center"
          ></el-table-column>
          <el-table-column
            width="200"
            prop="updateTime"
            label="刷新时间"
            align="center"
          ></el-table-column>

          <el-table-column
          v-if="$store.state.roleId == '1070960390067716097' || $store.state.roleId == '2125410685723869666'"
            prop="agentId"
            width="120px"
            label="agentId"
            align="center"
          >
          </el-table-column>
          <el-table-column
            width="130px"
            prop="appId"
            label="appId"
            align="center"
          ></el-table-column>
          <el-table-column
            width="110px"
            prop="merchantName"
            label="商户名"
            align="center"
          ></el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
            width="80px"
            prop="paymentFeeRate"
            label="代收费率"
            align="center"
          ></el-table-column>
          <el-table-column
            width="140px"
            prop="paymentAmount"
            :formatter="$formatter.FenToYuan"
            label="代收金额"
            align="center"
          ></el-table-column>
          <el-table-column
            v-if="$store.state.roleId == '1070960390067716097'"
            width="140px"
            prop="ydayNowPaymentAmount"
            :formatter="$formatter.FenToYuan"
            label="昨日当前"
            align="center"
          ></el-table-column>
          <el-table-column
            v-if="$store.state.roleId == '1070960390067716097'"
            width="140px"
            prop="sevenDayAvgPaymentAmount"
            :formatter="$formatter.FenToYuan"
            label="7日平均"
            align="center"
          ></el-table-column>
          <el-table-column
            v-if="$store.state.roleId == '1070960390067716097'"
            width="140px"
            prop="maxPaymentAmount"
            :formatter="$formatter.FenToYuan"
            label="历史最大金额"
            align="center"
          ></el-table-column>
          <el-table-column
            width="140px"
            prop="paymentFee"
            :formatter="$formatter.FenToYuan"
            label="代收手续费"
            align="center"
          ></el-table-column>
          <el-table-column
            v-if="$store.state.roleId == '1070960390067716097' || $store.state.roleId == '2125410685723869666'"
            prop="paymentAgentFee"
            width="90px"
            :formatter="$formatter.FenToYuan"
            label="代理利润"
            align="center"
          ></el-table-column>
          <el-table-column
            width="80px"
            prop="paymentCount"
            label="代收总数"
            align="center"
          ></el-table-column>
          <el-table-column
            width="90px"
            prop="paymentCountSuccess"
            label="代收成功数"
            align="center"
          ></el-table-column>
          <el-table-column
            v-if="$store.state.roleId == '1070960390067716097'"
            width="140px"
            prop="avgPaymentAmount"
            :formatter="$formatter.FenToYuan"
            label="平均收款金额"
            align="center"
          ></el-table-column>
          <el-table-column
            width="100px"
            prop="paymentCountSuccessRate"
            label="代收成功率"
            align="center"
          ></el-table-column>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
            width="80px"
            prop="transferFeeRate"
            label="代付费率"
            align="center"
          ></el-table-column>
          <el-table-column
            width="140px"
            prop="transferAmount"
            :formatter="$formatter.FenToYuan"
            label="代付金额"
            align="center"
          ></el-table-column>
          <el-table-column
            width="140px"
            prop="transferFee"
            :formatter="$formatter.FenToYuan"
            label="代付手续费"
            align="center"
          ></el-table-column>
          <el-table-column
            v-if="$store.state.roleId == '1070960390067716097' || $store.state.roleId == '2125410685723869666'"
            prop="transferAgentFee"
            width="90px"
            :formatter="$formatter.FenToYuan"
            label="代理利润"
            align="center"
          ></el-table-column>
          <el-table-column
            width="90px"
            prop="transferCount"
            label="代付总数"
            align="center"
          ></el-table-column>
          <el-table-column
            width="90px"
            prop="transferCountSuccess"
            label="代付成功数"
            align="center"
          ></el-table-column>
          <el-table-column
            width="100px"
            prop="transferCountSuccessRate"
            label="代付成功率"
            align="center"
          ></el-table-column>


          <el-table-column
            width="140px"
            prop="depositAmount"
            :formatter="$formatter.FenToYuan"
            label="充值金额"
            align="center"
          ></el-table-column>
          <el-table-column
            width="140px"
            prop="withdrawAmount"
            :formatter="$formatter.FenToYuan"
            label="提现金额"
            align="center"
          ></el-table-column>

          <!-- <el-table-column
            width="140px"
            prop="balance"
            :formatter="$formatter.FenToYuan"
            label="余额"
            align="center"
          ></el-table-column> -->

          <el-table-column
           v-if="$store.state.roleId == '1070960390067716097'"
           prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column
            v-if="$store.state.roleId == '1070960390067716097'"
            prop="bizPersonnelId"
            width="90px"
            label="商务id"
            align="center">
          </el-table-column>
          <el-table-column
            v-if="$store.state.roleId == '1070960390067716097'"
            prop="todayBizAmount"
            width="80px"
            :formatter="$formatter.FenToYuan"
            label="当日提成"
            align="center">
          </el-table-column>

        </template>
      </page>
    </div>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
import moment from "moment";

export default {
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/statistics-merchant/listStatisticsMerchant",
      merchantList: [],
      agentList: [],
      form: {
        appId: "",
        startDate: "",
        endDate: "",
        tradeOrderId: "",
      },
      timeDate: [],
      loading: false,
    };
  },
  methods: {
    timeChange(e) {
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      let start = moment().subtract(7, 'days').format('yyyyMMDD');;
      let end = moment().format('yyyyMMDD');
      this.form.startDate = start;
      this.form.endDate = end;
      this.timeDate = [start, end];
    },


    exportDetail() {
    this.loading = true
    let params = {
      agentId: this.form.agentId,
      appId: this.form.appId,
      startDate: this.form.startDate,
      endDate: this.form.endDate,
    };
    this.axios
      .post("/statistics-merchant/export", params)
      .then(res => {
        if (res.code != 200) {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'success',
          })
        }
      });
    this.loading = false
  },

  },

  created() {
    if (this.$store.state.roleId == '1070960390067716097') {
      this.$axios.get('/agent/selectAgentForOption', { params: {} })
        .then(res => {
          this.agentList = res.data
        })
    }

    this.$axios
      .get("/merchant/selectListForOption", { params: {} })
      .then((res) => {
        this.merchantList = res.data;
        if (this.merchantList.length == 1) {
          this.form.appId = this.merchantList[0].value;
          this.$bus.$emit("refresh");
        }
      });
  },
};
</script>
<style lang="scss" scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.el-form-item {
  margin-bottom: 5px;
}
</style>